export { BasicStore } from './basic'
export { JsonPatchStore, Instance, Op } from './jsonpatch'
export * from './store'
